import React from "react";
import PropTypes from "prop-types";

import { CareersList } from "./components/CareersList";

export default function Career({ pageContext: { career, careers } }) {
  return <CareersList career={career} careers={careers} />;
}

Career.propTypes = {
  pageContext: PropTypes.shape({
    career: PropTypes.object,
    careers: PropTypes.array,
  }),
};
